/**
 * Module dependencies.
 */

import { FC } from 'react';
import { ifProp, prop } from 'styled-tools';
import styled, { css } from 'styled-components';

/**
 * `SvgProps` interface.
 */

interface SvgProps {
  className?: string;
  color?: string;
  icon: string;
  size: string | unknown;
}

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.span`
  display: inline-block;
  line-height: 0;
  max-width: ${prop('size')};
  position: relative;
  width: ${prop('size')};

  ${ifProp(
    'color',
    css`
      color: ${prop('color')};
    `
  )}
`;

/**
 * `Svg` component.
 */

const Svg: FC<SvgProps> = ({ icon, ...rest }: SvgProps) => {
  const innerHtml = {
    __html: icon // eslint-disable-line id-match
  };

  return (
    <Wrapper
      {...rest}
      dangerouslySetInnerHTML={innerHtml}
    />
  );
};

/**
 * Export `Svg` component.
 */

export default Svg;
